import { useMutation, useQueryClient } from '@tanstack/react-query';
import { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useUser, useUserQueryKey } from '@doger/core/modules/auth';

import type { UserResponse } from '../api';
import { $$api } from '../api';

export const I18nSyncWithBackend = memo(() => {
  const { i18n } = useTranslation();
  const { data } = useUser();
  const { queryKey } = useUserQueryKey();
  const queryClient = useQueryClient();
  const updateLanguageMutation = useMutation({
    mutationKey: ['auth', 'user', 'language'],

    mutationFn: $$api.updateUserLanguage,

    onSuccess: (response) => {
      queryClient.setQueryData(queryKey, (old: UserResponse) => {
        if (!old) {
          return old;
        }

        return { ...old, language: response.language };
      });
    },
  });

  useEffect(() => {
    const isAuthenticated = !!data;

    if (isAuthenticated) {
      const isNotSameLanguage = data?.language !== i18n.language;

      if (isNotSameLanguage) {
        updateLanguageMutation.mutate({
          language: i18n.language,
        });
      }
    }

    return () => {};
  }, [i18n.language, data?.language]);

  return null;
});
